var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcExceptions({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08337 11.0333V9.59167C2.08337 7.86667 3.4917 6.45833 5.2167 6.45833H14.7834C16.5084 6.45833 17.9167 7.86667 17.9167 9.59167V10.7917H16.2334C15.7667 10.7917 15.3417 10.975 15.0334 11.2917C14.6834 11.6333 14.4834 12.125 14.5334 12.65C14.6084 13.55 15.4334 14.2083 16.3334 14.2083H17.9167V15.2C17.9167 16.925 16.5084 18.3333 14.7834 18.3333H10.2167",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08337 10.3417V6.53337C2.08337 5.5417 2.6917 4.65833 3.6167 4.30833L10.2334 1.80833C11.2667 1.41666 12.375 2.18335 12.375 3.29169V6.45834",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.799 11.6418V13.3585C18.799 13.8168 18.4324 14.1918 17.9657 14.2085H16.3324C15.4324 14.2085 14.6074 13.5501 14.5324 12.6501C14.4824 12.1251 14.6824 11.6335 15.0324 11.2918C15.3407 10.9751 15.7657 10.7918 16.2324 10.7918H17.9657C18.4324 10.8085 18.799 11.1835 18.799 11.6418Z",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83337 10H11.6667",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.75H6.95C7.48333 13.75 7.91667 14.1833 7.91667 14.7166V15.7833",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.51667 12.7334L2.5 13.75L3.51667 14.7666",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 18.15H3.46667C2.93334 18.15 2.5 17.7167 2.5 17.1833V16.1167",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.901 19.1669L7.91767 18.1503L6.901 17.1336",
    stroke: "#D1DAE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcExceptions);
export default __webpack_public_path__ + "static/media/ic_exceptions.01428016c6cbd055996c2f8887f5607b.svg";
export { ForwardRef as ReactComponent };